module.exports = __webpack_public_path__ + "static/media/4.24_preview.dc7d3266.png";